// extracted by mini-css-extract-plugin
export default {"colors":"accent,neutral,negative,warning,positive","item":"list-item_item__XQ2Mr","separator":"list-item_separator__bj9En","text":"list-item_text__k6bCu"};